var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C4.81331 12 3.65328 11.6481 2.66658 10.9888C1.67989 10.3295 0.910851 9.39246 0.456725 8.2961C0.0025997 7.19975 -0.11622 5.99335 0.115291 4.82946C0.346802 3.66557 0.918247 2.59648 1.75736 1.75736C2.59648 0.918247 3.66557 0.346802 4.82946 0.115291C5.99335 -0.11622 7.19975 0.0025997 8.2961 0.456725C9.39246 0.910851 10.3295 1.67989 10.9888 2.66658C11.6481 3.65328 12 4.81331 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12ZM6 0.857145C4.98284 0.857145 3.98852 1.15877 3.14278 1.72387C2.29705 2.28898 1.63787 3.09218 1.24862 4.03192C0.859371 4.97165 0.757526 6.00571 0.955964 7.00332C1.1544 8.00094 1.64421 8.91731 2.36345 9.63655C3.08269 10.3558 3.99906 10.8456 4.99668 11.044C5.9943 11.2425 7.02835 11.1406 7.96809 10.7514C8.90782 10.3621 9.71103 9.70296 10.2761 8.85722C10.8412 8.01148 11.1429 7.01716 11.1429 6C11.1429 4.63603 10.601 3.32793 9.63655 2.36345C8.67208 1.39898 7.36397 0.857145 6 0.857145Z",
    fill: "#969BA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.967 8.57139L5.57129 6.17568V2.14282H6.42843V5.81996L8.57129 7.96711L7.967 8.57139Z",
    fill: "#969BA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timerIcon.a4cbea53cda19265466aa250d7523e1b.svg";
export { ForwardRef as ReactComponent };